<div class="row justify-content-around">
    <div class="col-11 col-sm-10">

        <img src="assets/img/communauté/CCMA/Mont_avaloirs.JPG" class="img-fluid" style=" border-radius: 2em !important" alt="clem">

    </div>
  </div>
  
  